<div *ngIf="!invoice.id" style="margin-top: 32px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>
<div class="info-container" *ngIf="invoice.id">
  <div class="row" style="align-items: center;" *ngIf="canUpdate()">
    <div class="col-md-2 label" [style.visibility]="hasCouponsSetup ? 'visible' : 'hidden'">
      {{"bikeshop.modal.update_job_card.job_card.coupon_code" | translate}}:
    </div>
    <div class="col-4 value" [style.visibility]="hasCouponsSetup ? 'visible' : 'hidden'">
      <span *ngIf="reservation.paymentStatusID == 10">{{ discountCode || "-" }}</span>
      <p-inplace #couponCode *ngIf="reservation.paymentStatusID != 10">
        <span pInplaceDisplay>
          {{ discountCode }}
        </span>
        <span pInplaceContent>
          <div class="p-inputgroup">
            <input pInputText type="text" [(ngModel)]="discountCode"
                   (ngModelChange)="discountCode = $event.toUpperCase();couponError = null;"
                   (keyup.enter)="updateCouponCode(couponCode)" />
            <span *ngIf="!addingCoupon" class="p-inputgroup-addon" (click)="updateCouponCode(couponCode)">
              <i class="fa fa-check"></i>
            </span>
            <span *ngIf="addingCoupon" class="p-inputgroup-addon">
              <i class="fa fa-spinner fa-pulse"></i>
            </span>
          </div>
        </span>
      </p-inplace>
    </div>
    <div class="col-2">

    </div>
    <div class="col-4">
      <div class="product-search" joyrideStep="quoteStepOne">
        <p-autoComplete #productSearchComponent [(ngModel)]="productSearch" field="SKU"
                        [suggestions]="searchResult"
                        [minLength]="3"
                        [delay]="500" placeholder="{{
    'bikeshop.modal.update_job_card.quote.search_sku_or_other' | translate
  }}" (completeMethod)="searchProducts($event)" (onSelect)="addLineItemAuto($event)" [disabled]="editing">
          <ng-template let-product pTemplate="item">
            <div>
              <img *ngIf="product.ExternalProductID==''"
                   src="https://www.bicycleretailer.com/sites/default/files/styles/colorbox_popup/public/images/article/qualitybicycleproducts_logo_vert_rgb.jpg?itok=A20lWGap"
                   style="width:25px;display:inline-block;margin-right:5px;" />
              <span>
                {{ product.SKU }}
                - {{ product.Name }} {{
product.UnitPrice ? (' - ' + partner.CurrencySymbol +
                                    (partner.VATInclusive ? (product.UnitPrice_IncludingTax | number: ".2-2") : (product.UnitPrice |
                                        number: ".2-2"))) : ''
                }}
              </span>
            </div>
          </ng-template>
        </p-autoComplete>
        <span class="fa hubtiger-search"></span>
      </div>
    </div>
  </div>

  <div class="row margin-bottom-8" *ngIf="couponError">
    <div class="col-md-12 red bold" *ngIf="couponError">{{ couponError | translate }}</div>
  </div>

  <div class="quote-table">
    <div class="row header">
      <div class="col-2">
        {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
      </div>
      <div class="col-3">
        {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
      </div>
      <!--<div class="col-3">Description</div>-->
      <!--<div class="col-1">Brand</div>-->
      <div class="col-1 right" *ngIf="allowDiscount">
        <span>
          {{
            "bikeshop.modal.update_job_card.quote.discount_abbr" | translate
          }}
        </span>
      </div>
      <div class="col-1 right" *ngIf="!allowDiscount"></div>
      <div class="col-1 right">
        {{ "bikeshop.modal.update_job_card.quote.qty" | translate }}
      </div>
      <div class="col-2 right" *ngIf="!VATInclusive">
        {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
      </div>
      <div class="col-2 right" *ngIf="VATInclusive">
        <span>
          {{
            "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
          }}
        </span>
      </div>
      <div class="col-3 actions">
        <span class="fa fa-spinner fa-pulse" *ngIf="updatingQuote || sendingToPOS"
              style="height: fit-content"></span>
        <span pTooltip="{{
          'bikeshop.modal.update_job_card.quote.pos_sync_tooltip' | translate
        }}" tooltipPosition="bottom" class="fa hubtiger-sync" style="margin-left: auto;margin-right: 8px;"></span>

      </div>
    </div>
    <div *ngFor="let lineItem of invoice.lineItems; let i = index">
      <div *ngIf="!lineItem.edit" class="row line-item">
        <div class="col-2" style="display: flex; overflow:clip;">
          <span *ngIf="invoice.externalKey != null"
                [ngClass]="{'hubtiger-pos-not-sent': (lineItem.externalKey === null || lineItem.externalKey === '') && invoice.externalKey != null,
            'hubtiger-pos-sent': (lineItem.externalKey !== null && lineItem.externalKey !== '') && invoice.externalKey != null}"></span>
          {{ lineItem.sku }}
        </div>
        <div class="col-3">
          <div>{{lineItem.name}}</div>
          <div *ngIf="lineItem.lineItemNote" class="note">{{lineItem.lineItemNote}}</div>
        </div>

        <!--<div class="col-3">{{lineItem.Description}}</div>-->
        <!--<div class="col-1">{{lineItem.Brand}}</div>-->
        <div class="col-1 right" *ngIf="allowDiscount">
          {{ currencySymbol }}
          {{ (lineItem.discount ? lineItem.discount : 0) | number: ".2-2" }}
        </div>
        <div class="col-1 right" *ngIf="!allowDiscount"></div>
        <div class="col-1 right">
          <span *ngIf="!canUpdate()">{{ lineItem.quantity }}</span>
          <p-inplace #qty (click)="lineItem.edit = true" *ngIf="!editing && canUpdate()">
            <span pInplaceDisplay>
              {{ lineItem.quantity }}
            </span>
            <span pInplaceContent>
              <div class="p-inputgroup">
                <input type="number" min="0" pInputText [(ngModel)]="lineItem.quantity" #qty
                       (keyup.enter)="updateLineItem(lineItem)" placeholder="{{
                  'bikeshop.modal.update_job_card.quote.qty' | translate
                }}" />
              </div>
            </span>
          </p-inplace>
          <span *ngIf="editing">{{ lineItem.Quantity }}</span>
        </div>
        <div class="col-2 right" *ngIf="!VATInclusive">
          {{ currencySymbol }} {{ lineItem.unitPrice | number: ".2-2" }}
        </div>
        <div class="col-2 right" *ngIf="VATInclusive">
          <span *ngIf="VATInclusive">
            {{ currencySymbol }}
            {{ lineItem.unitPrice_IncludingTax | number: ".2-2" }}
          </span>
        </div>
        <div class="col-3 actions" *ngIf="canUpdate()">
          <span class="fa fa-fw hubtiger-edit" (click)="editLineItem(i)"
                *ngIf="!updatingQuote && !editing && !sendingToPOS" title="Edit line item."></span>
          <span class="fa fa-fw hubtiger-delete" (click)="deleteLineItem(lineItem)"
                *ngIf="!updatingQuote && !editing && !sendingToPOS" title="{{
            'bikeshop.modal.update_job_card.quote.delete_line_item_from_quote'
              | translate
          }}"></span>
          <span class="fa fa-fw"
                [ngClass]="{ 'hubtiger-sticky-note': lineItem.lineItemNote === undefined || lineItem.lineItemNote === null || lineItem.lineItemNote === '', 'hubtiger-sticky-note-text': lineItem.lineItemNote !== undefined && lineItem.lineItemNote !== null && lineItem.lineItemNote.length > 0 }"
                *ngIf="!updatingQuote && !editing && !sendingToPOS"
                pTooltip="{{lineItem.lineItemNote === undefined || lineItem.lineItemNote === null || lineItem.lineItemNote === '' ? ('bikeshop.modal.update_job_card.quote.add_line_item_note' | translate) : lineItem.lineItemNote}}"
                tooltipPosition="bottom" (click)="lineItemNoteUpdate.toggle($event)"></span>
          <div style="position: absolute;right: 430px;margin-top: 16px;">
            <p-overlayPanel #lineItemNoteUpdate [dismissable]="false" [showCloseIcon]="true"
                            (onShow)="notePanelVisible()" (onHide)="notePanelHidden()">
              <div style="width: 400px;">
                <div class="overlay-title">
                  {{
'bikeshop.modal.update_job_card.quote.add_line_item_note' |
                                    translate
                  }}
                </div>
                <div class="p-inputgroup">
                  <textarea [rows]="5" pInputTextarea [(ngModel)]="lineItem.lineItemNote"></textarea>
                </div>
                <div style="display:flex;justify-content: flex-end;margin-top: 8px;">
                  <button pButton type="button" class="p-button-raised"
                          (click)="updateLineItemNote(lineItem, lineItemNoteUpdate)"
                          label="{{'bikeshop.modal.update_job_card.quote.update_note'| translate}}"></button>
                </div>
              </div>
            </p-overlayPanel>
          </div>
        </div>
      </div>
      <div></div>
      <div *ngIf="lineItem.edit" class="row line-item edit">
        <div class="col-2">{{ lineItem.sku }}</div>
        <div class="col-3">{{ lineItem.name }}</div>
        <!--<div class="col-1">{{editLine.Brand}}</div>-->
        <div class="col-1" *ngIf="allowDiscount" style="overflow:visible">
          <div *ngIf="discountType === 'AMOUNT'">
            <input type="number" pInputText [(ngModel)]="lineItem.discount" />
          </div>
          <div class="p-inputgroup" *ngIf="discountType === 'PERCENTAGE'">
            <p-dropdown [options]="discounts" class="full-width"
                        [(ngModel)]="lineItem.discountID"></p-dropdown>
          </div>
        </div>
        <div class="col-1 right" *ngIf="!allowDiscount"></div>
        <div class="col-1 right">
          <input type="number" min="0" pInputText [(ngModel)]="lineItem.quantity" #quantityComponent
                 (keyup.enter)="updateLineItem(lineItem)" placeholder="{{
            'bikeshop.modal.update_job_card.quote.qty' | translate
          }}" />
        </div>
        <div class="col-2 right" style="overflow:visible">
          <input *ngIf="VATInclusive" type="number" pInputText [(ngModel)]="lineItem.unitPrice_IncludingTax"
                 placeholder="{{
              'bikeshop.modal.update_job_card.quote.unit_price' | translate
            }}" style="text-align: right; margin-right: -16px; padding-right: 25px;" />
          <input *ngIf="!VATInclusive" type="number" pInputText [(ngModel)]="lineItem.unitPrice"
                 placeholder="{{
              'bikeshop.modal.update_job_card.quote.unit_price' | translate
            }}" style="text-align: right; margin-right: -16px; padding-right: 25px;" />
        </div>
        <div class="col-3 actions">
          <span class="save" *ngIf="lineItem.unitPrice >= 0 && !updatingQuote" (click)="updateLineItem(lineItem)">
            {{
              "bikeshop.general.save" |
                  translate
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="totals">
      <div class="row" *ngIf="allowDiscount">
        <div class="col-5"></div>
        <div class="col-2 right">
          {{ "bikeshop.modal.update_job_card.quote.discount" | translate }}:
        </div>
        <div class="col-2 right">
          {{ currencySymbol }}
          {{ invoice.discount | number: ".2-2" }}
        </div>
      </div>
      <div class="row">
        <div class="col-5"></div>
        <div class="col-2 right">
          {{ "bikeshop.modal.update_job_card.quote.sub-total" | translate }}:
        </div>
        <div class="col-2 right">
          {{ currencySymbol }}
          {{ invoice.subTotal | number: ".2-2" }}
        </div>
      </div>
      <div class="row" *ngIf="helpersService.showTaxRow(invoice.tax, partner)">
        <div class="col-5"></div>
        <div class="col-2 right">
          {{ "bikeshop.modal.update_job_card.quote.vat" | translate }}:
        </div>
        <div class="col-2 right">
          {{ currencySymbol }} {{ invoice.tax | number: ".2-2" }}
        </div>
      </div>
      <div class="row">
        <div class="col-5"></div>
        <div class="col-2 right">
          {{ "bikeshop.modal.update_job_card.quote.total" | translate }}:
        </div>
        <div class="col-2 right">
          {{ currencySymbol }}
          {{ invoice.total | number: ".2-2" }}
        </div>
      </div>
    </div>
  </div>


  <div class="row margin-top-16" *ngIf="canSendToPOS() && !invoice.hasSplitPayments">
    <div class="col-md-2"></div>
    <div class="col-md-4">
      <div *ngIf="invoice.externalKey">
        <button pButton type="button" *ngIf="invoice.externalKey && (partner.POSSystemID === 6)"
                [disabled]="updatingQuote || editing  || sendingToPOS || partner.POSSystemID <= 0"
                class="p-button-raised full-width alternate" (click)="openPOSURL()"
                label="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ POSName }}"></button>
      </div>
    </div>
    <div class="col-md-4">
      <button pButton type="button" class="p-button-raised full-width" (click)="sendToPOS()"
              [disabled]="updatingQuote || editing || sendingToPOS || partner.POSSystemID <= 0 || invoice.externalStatusID == 10 || !canUpdate()"
              label="{{ 'bikeshop.modal.update_job_card.quote.button.send_to_pos' | translate}} {{ POSName }}"></button>
    </div>
  </div>

</div>

<div class="info-container" *ngIf="invoice.id && !canSendToPOS() && partner.POSSystemID > 0">
  <div style="margin-top: 8px;
  color: #c30101;
  font-family: Montserrat;
  font-weight: 500;">
    Please note that we can currently only send quotes to Lightspeed (R-Series), Lightspeed (X-Series),
    Shopify, Citrus Lime & Square, we will be adding the remainder of the point of sales soon.
  </div>
</div>

<div class="info-container" *ngIf="invoice.id">
  <div class="rental-duration">
    <div>{{ 'bikeshop.rentals.booking.rental_duration' | translate }}:</div>
    <ul>
      <li *ngIf="reservation.reservationDuration.days">
        {{reservation.reservationDuration.days}} {{
                reservation.reservationDuration.days > 1 ? ('bikeshop.rentals.booking.days' | translate) :
                    ('bikeshop.rentals.booking.day' | translate)
        }}
      </li>
      <li *ngIf="reservation.reservationDuration.hours">
        {{reservation.reservationDuration.hours}} {{
                reservation.reservationDuration.hours > 1 ? ('bikeshop.rentals.booking.hours' | translate) :
                    ('bikeshop.rentals.booking.hour' | translate)
        }}
      </li>
    </ul>
  </div>
  <div class="rental-summary">
    <div>{{ 'bikeshop.rentals.booking.rental_summary' | translate }}</div>
    <ul *ngFor="let product of reservation.reservedProducts">
      <li>
        <div>
          {{product.brand}} {{product.model}} {{product.color}} ({{product.size}}
          ) {{product.serialNumber}}
        </div>
        <!-- <div>{{partner.CurrencySymbol}}{{product.hourlyRate}}/hour ➡️
          {{partner.CurrencySymbol}}{{product.dailyRate}}/day</div> -->
      </li>
      <div *ngIf="product.reservedAccessories && product.reservedAccessories.length > 0">
        <ul *ngFor="let accessory of product.reservedAccessories">
          <li>
            <div>
              {{accessory.brand}} {{accessory.name}} {{accessory.color}} ({{accessory.size}})
              {{accessory.serialNumber}}
            </div>
            <!-- <div>{{partner.CurrencySymbol}}{{accessory.hourlyRate}}/hour ➡️
              {{partner.CurrencySymbol}}{{accessory.dailyRate}}/day</div> -->
          </li>
        </ul>
      </div>
    </ul>
  </div>
</div>

<app-rental-payment-status *ngIf="invoice.id"
                           [partner]="partner"
                           [countryData]="countryData"
                           [reservation]="reservation"
                           [qrCodeURL]="qrCodeURL"
                           [invoice]="invoice"
                           [reservationPaymentHistory]="reservationPaymentHistory"
                           (reloadReservation)="reloadReservationLoc($event)"></app-rental-payment-status>

<app-rental-reservation-long-term-payment-schedule *ngIf="invoice.id"
                                                   [partner]="partner"
                                                   [reloadPaymentSchedule]="reloadPaymentSchedule"
                                                   (clearReloadPaymentScheduleFlag)="reloadPaymentSchedule = false;"
                                                   [countryData]="countryData"
                                                   [reservation]="reservation"
                                                   (reloadReservation)="reloadReservationLoc($event)"></app-rental-reservation-long-term-payment-schedule>

<app-rental-reservation-security-deposit-info *ngIf="invoice.id"
                                              [partner]="partner"
                                              [countryData]="countryData"
                                              [reservation]="reservation"></app-rental-reservation-security-deposit-info>

<p-confirmDialog key="coupon_confirm" header="Confirmation"></p-confirmDialog>
